const CristaleroIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="glazier"
  >
    <title>a-icons / 32px / services / crystal glassworker</title>
    <g
      id="a-icons-/-32px-/-services-/-crystal-glassworker"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M31.5,0 C31.7453333,0 31.9495802,0.176987654 31.9919396,0.410161866 L32,0.5 L32,31.5 C32,31.7453333 31.8230123,31.9495802 31.5898381,31.9919396 L31.5,32 L0.5,32 C0.254666667,32 0.0504197531,31.8230123 0.00806035665,31.5898381 L0,31.5 L0,0.5 C0,0.254666667 0.176987654,0.0504197531 0.410161866,0.00806035665 L0.5,0 L31.5,0 Z M31,1 L1,1 L1,31 L31,31 L31,1 Z M29.632,1.869 C29.8773333,1.869 30.0815802,2.04519753 30.1239396,2.27889849 L30.132,2.369 L30.132,29.631 C30.132,29.8772222 29.9550123,30.0807778 29.7218381,30.1229726 L29.632,30.131 L2.369,30.131 C2.12366667,30.131 1.91941975,29.9548025 1.87706036,29.7211015 L1.869,29.631 L1.869,2.369 C1.869,2.12277778 2.04598765,1.91922222 2.27916187,1.87702743 L2.369,1.869 L29.632,1.869 Z M15.5,16.5 L2.869,16.5 L2.869,29.131 L15.5,29.131 L15.5,16.5 Z M29.132,16.5 L16.5,16.5 L16.5,29.131 L29.132,29.131 L29.132,16.5 Z M15.5,2.869 L2.869,2.869 L2.869,15.5 L15.5,15.5 L15.5,2.869 Z M29.132,2.869 L16.5,2.869 L16.5,15.5 L29.132,15.5 L29.132,2.869 Z"
        id="Shape"
        fill={color || '#00008F'}
      ></path>
    </g>
  </svg>
);

export default CristaleroIcon;
